import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const left = (iso) => Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 60000));

export const useTownTrash = (onRestored) => {
  const [batches, setBatches] = useState([]);
  const load = useCallback(() => api.get("/towns/trash").then((r) => setBatches(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const restore = async (id) => {
    try {
      const { data: d } = await api.post(`/towns/trash/${id}/restore`);
      toast.success(`${d.restored} town${d.restored === 1 ? "" : "s"} restored`);
      if (d.skipped.length) toast.warning(`Already back in the list: ${d.skipped.join(", ")}`);
      onRestored();
    } catch (e) { toast.error(errMsg(e)); }
    load();
  };
  const announce = (batchId, label) => {
    load();
    if (batchId) toast.success(`${label} deleted`, { duration: 10000, action: { label: "Undo", onClick: () => restore(batchId) } });
  };
  return { batches, restore, announce };
};

export const UndoBar = ({ batches, restore }) => {
  if (!batches.length) return null;
  return (
    <div className="mb-4 space-y-2" data-testid="towns-undo-bar">
      {batches.map((b) => (
        <div key={b.batch_id} data-testid={`towns-undo-${b.batch_id}`} className="flex flex-wrap items-center gap-3 border border-[#E2D9CC] bg-[#F4EFE6] px-4 py-2.5 text-sm">
          <span className="text-[#1C181D]">Deleted {b.towns.length > 3 ? `${b.towns.slice(0, 3).join(", ")} and ${b.towns.length - 3} more` : b.towns.join(", ")}</span>
          <span className="text-xs text-[#8C827A]">Undo available for {left(b.expires_at)} more min</span>
          <button data-testid={`towns-undo-btn-${b.batch_id}`} onClick={() => restore(b.batch_id)} className="ml-auto inline-flex items-center gap-1.5 px-3 py-1 border border-[#3B1B48] text-[#3B1B48] hover:bg-[#3B1B48] hover:text-[#FAF7F2] transition-colors"><Undo2 className="w-3.5 h-3.5" />Undo</button>
        </div>
      ))}
    </div>
  );
};
